<template>
  <va-modal
    id="transferAppointmentsModal"
    size="large"
    :value="showModal"
    :noOutsideDismiss="true"
    :okText="$t('modals.buttons.save')"
    :cancelText="$t('modals.buttons.cancel')"
    :okDisabled="isSubmitting || !canSubmitForm || selectedAppointmentIds.length === 0"
    @ok="submit"
    @cancel="cancel">

    <div slot="header" class="modal-title">
      {{ $t('entities.activities.revision.title')}}
    </div>

    <span></span>

    <div class="header">

      <div class="label-info mb-1">
        <span>{{ getModalBody }}</span>
      </div>
      <div class="label-info is-bold">
        {{ $t('entities.activities.first_start') }}:&nbsp;<span>{{ firstStart }}</span>
      </div>

      <div class="label-info is-bold">
        {{ $t('entities.activities.last_end') }}:&nbsp;<span>{{ lastEnd }}</span>
      </div>

      <div class="label-info mt-3">
        <span></span>
        <span>{{ $t('entities.activities.transfer_appointments.body') }} </span>
        <div class="list mt-2">
          <div
            v-for="(appointment, index) in appointments"
            :key="appointment.id">

            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex justify-content-start align-items-center">
                <div>
                  <va-checkbox
                    :value="selectedAppointmentIds.includes(appointment.id)"
                    @input="handleSelectAppointment(appointment.id)"
                    :isCircle="true"
                  />
                </div>

                <div >
                  <div class="row col-12">
                    <span class="label-info is-bold"> {{$t('entities.activities.transfer_appointments.date')}} </span>
                    <span class="label-info"> &nbsp;{{handleDate(appointment)}} </span>
                  </div>
                  <div class="row col-12">
                    <span class="label-info is-bold"> {{$t('entities.activities.transfer_appointments.patient')}} </span>
                    <span class="label-info"> &nbsp;{{appointment.person ? appointment.person.name : 'N/A'}} </span>
                  </div>
                  <div class="row col-12">
                    <span class="label-info is-bold"> {{$t('entities.activities.transfer_appointments.dispenser')}} </span>
                    <span class="label-info"> &nbsp;{{ handleDispenser(appointment) }} </span>
                  </div>
                  <div class="row col-12">
                    <span class="label-info is-bold"> {{$t('entities.activities.transfer_appointments.facility')}} </span>
                    <span class="label-info"> &nbsp;{{ handleFacility(appointment) }} </span>
                  </div>
                </div>
              </div>
            </div>
            <hr v-if="index !== appointments.length - 1">
          </div>
          </div>
        </div>

      <div class="row col-12 mt-5">
        <span> {{ $t('entities.activities.transfer_appointments.count_appointments', {count: selectedAppointmentIds.length}) }} </span>
      </div>
    </div>

  </va-modal>
</template>
<script>
import LoadingAnimation from '@/components/common/LoadingAnimation'
import EntityActivityUserInfo from '@/components/entity-activity-user/EntityActivityUserInfo'
import { AppointmentService } from '@/api/AuthClinicalService'

export default {
  props: {
    appointments: {
      type: Array,
      required: true
    },
    entityActivityUser: {
      type: Object,
      required: true
    }
  },
  components: {
    LoadingAnimation,
    EntityActivityUserInfo
  },
  data () {
    return {
      showModal: false,
      isSubmitting: false,
      isLoading: true,
      selectedAppointmentIds: []
    }
  },
  mounted () {
    this.toggleModalVisibility()
  },
  methods: {
    handleSelectAppointment (appointmentId) {
      if (this.selectedAppointmentIds.includes(appointmentId)) {
        this.selectedAppointmentIds.splice(this.selectedAppointmentIds.findIndex(item => item === appointmentId), 1)
      } else {
        this.selectedAppointmentIds.push(appointmentId)
      }
    },
    handleDispenser (data) {
      if (data.user && data.user.name && data.user.nickname) {
        return `${data.user.name} (${data.user.nickname})`
      }
      if (data.user && data.user.name) {
        return data.user.name
      }
      return 'N/A'
    },
    handleFacility (appointment) {
      let city = appointment.facility.address.city
      let facility = appointment.facility ? appointment.facility.name : 'N/A'

      if (appointment.facility && city) {
        return `${facility} (${city})`
      }
      if (appointment.facility) {
        return facility
      }
    },
    handleDate (appointment) {
      let date = this.moment(this.$options.filters.localTime(appointment.start)).format('YYYY-MM-DD')
      let start = this.moment(this.$options.filters.localTime(appointment.start)).format('hh:mm')
      let end = this.moment(this.$options.filters.localTime(appointment.end)).format('hh:mm')
      return `${date} ${start} - ${end}`
    },
    toggleModalVisibility: function () {
      this.showModal = !this.showModal
    },

    submit: function () {
      let params = {}
      params.appointment_ids = this.selectedAppointmentIds
      params.entity_activity_user_id = this.entityActivityUser.id
      AppointmentService.transferAppointments(this.$store.state.auth_clinical_server, params).then(transferredCount => {
        this.$emit('transferred', transferredCount)
      }).catch(err => {
        this.$emit('cancel', true)
        console.log(err)
      })
    },

    cancel: function () {
      this.$emit('cancel', false)
    },

  },
  computed: {
    firstStart () {
      let starts = this.appointments.map(item => new Date(item.start))
      let firstStart = starts.sort((a, b) => {
        return a - b
      })[0]

      return this.moment(firstStart).format('YYYY-MM-DD')
    },
    lastEnd () {
      let ends = this.appointments.map(item => new Date(item.end))
      let lastEnd = ends.sort((a, b) => {
        return b - a
      })[0]

      return this.moment(lastEnd).format('YYYY-MM-DD')
    },
    getModalBody: function () {
      if (this.appointments.length > 1) {
        return `${this.$t('entities.activities.transfer_appointments.multiple_transfer', { number: this.appointments.length })}.`
      } else if (this.appointments.length === 1) {
        return `${this.$t('entities.activities.transfer_appointments.single_transfer')}.`
      }
    },
    canSubmitForm: function () {
      return this.selectedEntityActivityUser !== null
    },
    filteredEntitiesActivitiesUsers: function () {
      return this.entitiesActivitiesUsers.filter(_entityActivityUser => _entityActivityUser.id !== this.entityActivityUser.id)
    },
  }
}
</script>
<style lang="scss">
.appointment {
  & .label-info {
    margin-left: 0.5rem;
    margin-bottom: 0.7rem;
    color: #48494B;
    & span {
      font-weight: bold;
    }
  }
}
</style>
